import FingerprintJS from '@fingerprintjs/fingerprintjs'
//判断页面显示什么语言
var langArr=["zh-cn.aiseesoft","zh-tw.aiseesoft","cs.aiseesoft","da.aiseesoft","nl.aiseesoft","fi.aiseesoft",".fr",".de","el.aiseesoft","it.aiseesoft",".jp","no.aiseesoft","pl.aiseesoft","pt.aiseesoft","ru.aiseesoft","es.aiseesoft","sv.aiseesoft","hu.aiseesoft","tr.aiseesoft"];
window.lang='en';
for(var i=0;i<langArr.length;i++){
    if(location.href.indexOf(langArr[i])>-1){
        if(langArr[i]=='.fr' || langArr[i]=='.de'){
            lang=langArr[i].split('.')[1];
        }else if(langArr[i]=='.jp'){
            lang='ja'
        }else{
            lang=langArr[i].split('.')[0];
        }
        break;
    }else{
        lang='en';
    }
};

// 请求接口地址
window.domain=".aiseesoft.com";
window.post_url='';
window.accountHref='';
// if(location.hostname=='www.aiseesoft.com' || 
// location.hostname=='www.aiseesoft.fr' || 
// location.hostname=='www.aiseesoft.de' || 
// location.hostname=='www.aiseesoft.jp' || 
// location.hostname=='zh-cn.aiseesoft.com' || 
// location.hostname=='zh-tw.aiseesoft.com' || 
// location.hostname=='cs.aiseesoft.com' || 
// location.hostname=='da.aiseesoft.com' || 
// location.hostname=='nl.aiseesoft.com' || 
// location.hostname=='fi.aiseesoft.com' || 
// location.hostname=='el.aiseesoft.com' || 
// location.hostname=='it.aiseesoft.com' || 
// location.hostname=='no.aiseesoft.com' || 
// location.hostname=='pl.aiseesoft.com' || 
// location.hostname=='pt.aiseesoft.com' || 
// location.hostname=='ru.aiseesoft.com' || 
// location.hostname=='es.aiseesoft.com' || 
// location.hostname=='sv.aiseesoft.com' || 
// location.hostname=='hu.aiseesoft.com' || 
// location.hostname=='tr.aiseesoft.com'
// ){
//     post_url="https://account.api.aiseesoft.com/v9/";
//     accountHref="https://account.aiseesoft.com/";
// }else{
//     post_url="https://sandbox.account.api.aiseesoft.com/v9/";
//     accountHref="https://sandboxaccount.aiseesoft.com/";
// }
if(location.hostname==hostUrl || 
    location.hostname==hostUrlFr || 
    location.hostname==hostUrlDe || 
    location.hostname==hostUrlJp || 
    location.hostname==hostUrlZhcn || 
    location.hostname==hostUrlZhtw || 
    location.hostname==hostUrlCs || 
    location.hostname==hostUrlDa || 
    location.hostname==hostUrlNl || 
    location.hostname==hostUrlFi || 
    location.hostname==hostUrlEl || 
    location.hostname==hostUrlIt || 
    location.hostname==hostUrlNo || 
    location.hostname==hostUrlPl || 
    location.hostname==hostUrlPt || 
    location.hostname==hostUrlRu || 
    location.hostname==hostUrlEs || 
    location.hostname==hostUrlSv || 
    location.hostname==hostUrlHu || 
    location.hostname==hostUrlTr
    ){
        // var imagePost=imagePost;
        post_url=postUrl;
        accountHref=accountHref_pro;
}else{
    // var imagePost=imagePostDev
     post_url=post_url_dev;
     accountHref=accountHrefDev;
}
$(document).click(function(){
    if($('.photo_guide_box').css('display')=='none'){
        $('.pensize-change-container').hide();
    }
    $('.hb_type .hb.active').addClass('c');
    $('.hb_type .eraser.active').addClass('c');
    $('.photo_guide_box').removeClass('active');
    $('.save_guide').removeClass('active');
    $('.remove_guide').removeClass('active');
    // $('.photo_rights').hide()
    $('.photo_rights').removeClass('show');
    $('.photo_rights_load').hide();
    $('.photo_toggle_box').hide();
    $('.photoHistory_box').removeClass('active');
    $('.header .login ul').hide()
    // hb_pensize=1;
    // xp_pensize=1;
});
function getLang(){
    var url = window.location.host;
    var lang = getCookie('lang');
    if(!lang){
        lang = localStorage.getItem('lang')
    }
    try {
        var urlArr = url.split(".");
        if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp'){
            lang=urlArr[2];
        }
    }catch(e){

    }
    return lang;
};
function isDomain(){
    var url = window.location.host;
    try {
        var urlArr = url.split(".");
        if(urlArr[2]=='de' || urlArr[2]=='fr' || urlArr[2]=='jp'){
            return true;
        }
    }catch(e){

    }
    return false;
};
//获取浏览器唯一码
window.murmur=1;
window.oldmurmur=1;
window.getvisitorId = async function(){
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    const visitorId = result.visitorId
    murmur=visitorId;
    oldmurmur=visitorId;
    // if(isDomain()){
        murmur=murmur.slice(0, -2)+getLang()
    // }
    console.log(oldmurmur,murmur);
    
}
getvisitorId();
//获取cookie
window.getCookie=function(name){
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
 
    if (start == -1) {
        return null;
    }
 
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
 
    var value = document.cookie.substring(start + prefix.length, end)
    return unescape(value);
}
// 判断是否有为google登陆跳过来的
if(getCookie('google_key')){
    $.ajaxSettings.async = false;
    function MemberOauthInfo(){
        $.post(
            post_url+'account/google/oauth/info',
            {
                e_id:murmur,
                key:getCookie('google_key')
            },
            function(data){
                error_fn(data.error);
                setCookie('google_key',"",-1);
                switch(data.error){
                    case 0:
                        setCookie('user_google',JSON.stringify({'google_id_token':data.id_token}),90);
                        google_login()
                        break;
                    case 26701:
                        error(i18n[lang].error_26701);
                        break;
                    case 26702:
                        error(i18n[lang].error_26702);
                        break;
                    case 26703:
                        error(i18n[lang].error_26703);
                        break;
                    case 26704:
                        error(i18n[lang].error_26704);
                        break;
                    case 26705:
                        MemberOauthInfo();
                        break;
                }
            }
        ).fail(function(xhr){
            overtime(26799);
        });
    }
    MemberOauthInfo();
    $.ajaxSettings.async = true;
}
window.user='';
window.personal='';
window.userProfile=function(callback,fail){
    $.post(
        post_url+'account/profile',
        {
            e_id:user.e_id,
            t_id:user.t_id,
            token:user.token
        },
        function(data){
            personal=data;
            error_fn(data.error)
            switch(data.error){
                case 0:
                    $('.header .right>.login').removeClass('MemberLogin')
                    $('.header .right>.login>span').hide()
                    if(data.picture){
                        $('.login ul li div img').attr('src',data.picture);
                        $('.header .right>.login>img').attr('src',data.picture);
                    }
                    if(data.nickname){
                        $('.login ul li').eq(0).find('.name').html(HtmlUtil.htmlEncode(data.nickname));
                    }else{
                        if(data.email){
                            try{
                                var nickname=data.email.split('@')[0];
                            }catch(e){
                                console.log(e);
                            }
                            $('.login ul li').eq(0).find('.name').html(HtmlUtil.htmlEncode(nickname));
                        }else{
                            $('.login ul li').eq(0).find('.name').html(data['3rdparty'][0]['name']);
                        }
                    }
                    if(callback){
                        callback();
                    }
                    break;
                case 20901:
                    error(i18n[lang].error_20901);
                    if(fail){
                        fail();
                    }
                    break;
                case 20902:
                    error(i18n[lang].error_20902);
                    if(fail){
                        fail();
                    }
                    break;
            };
        }
    ).fail(function(xhr){
        overtime(20499);
    })
}
if(getCookie('user')){
    user=JSON.parse(getCookie('user'));
    //查询资料
    userProfile()
    //退出登录
    $('.logout').click(function(e){
        e.stopPropagation();
        $.post(
            post_url+'account/logout',
            {
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token
            },
            function(data){
                error_fn(data.error);
                switch(data.error){
                    case 0:
                        $('.login_btn>a').show();
                        $('.login_box').hide();
                        setCookie("user","",-1)
                        break;
                    case 20401:
                        error(i18n[lang].error_20401);
                        break;
                }
            }
        ).fail(function(xhr){
            overtime(20499);
        })
    });
}else{
    $('.login_btn>a').show();
    $('.login_box').hide();
};
$('.login_btn>a').attr('href',accountHref+'login?source='+location.href);
//google登录接口函数
function google_login(callback,registerCallback,mergeCallback){
    $.post(
        post_url+'account/google/login',
        {
            e_id:murmur,
            id_token:JSON.parse(getCookie('user_google')).google_id_token
        },
        function(data){
            error_fn(data.error);
            switch(data.error){
                case 0:
                    setCookie('user',JSON.stringify({'e_id':murmur,'t_id':data.t_id,'token':data.token}),90);
                    break;
                case 21601:
                    error(i18n[lang].error_21601);
                    break;
                case 21602:
                    error(i18n[lang].error_21602);
                    break;
                case 21603:
                    error(i18n[lang].error_21603);
                    break;
                case 21604:
                    error(i18n[lang].error_21604);
                    break;
                case 21605:
                    // 不提示，自动去创建账号并登录
                    if(registerCallback){
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    break;
                case 21606:
                    error(i18n[lang].error_21606);
                    break;
                case 21607:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if(mergeCallback){
                        mergeCallback()
                        return false;
                    }
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21608:
                    //自动帮忙注册一个账号
                    if(registerCallback){
                        registerCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    break;
                case 21609:
                    // 不提示，不去注册，跳转是否合并邮箱页面
                    if(mergeCallback){
                        mergeCallback()
                        return false;
                    }
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21610:
                    // 不提示，自动去注册一个3方账号并登录；创建成功后选择绑定，自动填充获得的Google 邮箱，同21608
                    if(registerCallback&&mergeCallback){
                        registerCallback()
                        mergeCallback()
                        return false;
                    }
                    third_party_registered_fn(0);
                    location.href=accountHref+"3rd-login-merge-account";
                    break;
                case 21611:
                    error(i18n[lang].error_21611);
                    break;
            }
        }
    ).fail(function(xhr){
        overtime(21699);
    })
};
// google账号注册
function third_party_registered_fn(operation,callback,callbackGoogle){
    if(!isnetwork()){return false;};
    let data={
        e_id:murmur,
        id_token:JSON.parse(getCookie('user_google')).google_id_token
    };
    switch(operation){
        case 0:
            data={
                e_id:murmur,
                id_token:JSON.parse(getCookie('user_google')).google_id_token
            }
            break;
        case 21607:
            data={
                e_id:murmur,
                id_token:JSON.parse(getCookie('user_google')).google_id_token,
                connect:1
            }
            break;
        case 21608:
            break;
        case 21609:
            break;
        case 21610:
            break;
    }
    $.post(
        post_url+'account/google/register',data,
        function(data){
            error_fn(data.error);
            switch(data.error){
                case 0:
                    setCookie('user',JSON.stringify({'e_id':murmur,'t_id':data.t_id,'token':data.token}),90);
                    if(operation==21607){
                        if(callback){
                            callback();
                            return false;
                        }
                    }else{
                        if(callback){
                            callback();
                            return false;
                        }
                    }
                    break;
                case 21801:
                    error(i18n[lang].error_21801);
                    break;
                case 21802:
                    error(i18n[lang].error_21802);
                    break;
                case 21803:
                    error(i18n[lang].error_21803);
                    break;
                case 21804:
                    error(i18n[lang].error_21804);
                    break;
                case 21805:
                    if(callbackGoogle){
                        callbackGoogle()
                        return false;
                    }
                    google_login()
                    break;
                    // 不提示，重新三方登录到新的账号上
                case 21806:
                    error(i18n[lang].error_21806);
                    break;
                case 21807:
                    error(i18n[lang].error_21807);
                    break;
                case 21808:
                    error(i18n[lang].error_21808);
                    break;
                case 21809:
                    error(i18n[lang].error_21809);
                    break;
                case 21810:
                    error(i18n[lang].error_21810);
                    break;
                case 21811:
                    error(i18n[lang].error_21811);
                    break;
                case 21812:
                    error(i18n[lang].error_21812);
                    break;
                case 21813:
                    error(i18n[lang].error_21813);
                    break;
                case 21814:
                    error(i18n[lang].error_21814);
                    break;
                case 21815:
                    error(i18n[lang].error_21815);
                    break;
                case 21816:
                    error(i18n[lang].error_21816);
                    break;
                case 21817:
                    error(i18n[lang].error_21817);
                    break;
                case 21818:
                    error(i18n[lang].error_21818);
                    break;
                case 21819:
                    error(i18n[lang].error_21819);
                    break;
                case 21820:
                    error(i18n[lang].error_21820);
                    break;
                case 21821:
                    error(i18n[lang].error_21821);
                    break;
                case 21822:
                    error(i18n[lang].error_21822);
                    break;
                case 21823:
                    error(i18n[lang].error_21823);
                    break;
                case 21824:
                    error(i18n[lang].error_21824);
                    break;
                case 21825:
                    error(i18n[lang].error_21825);
                    break;
                case 21826:
                    error(i18n[lang].error_21826);
                    break;
            }
        }
    ).fail(function(xhr){
        overtime(21899);
    })
}
// 判断是否有网
function isnetwork(){
    if(!navigator.onLine){
        error(i18n[lang].isnetwork);
        return false;
    }else{
        return true;
    }
};

var HtmlUtil = {
    /*1.用浏览器内部转换器实现html转码*/
    htmlEncode:function (html){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement ("div");
        //2.然后将要转换的字符串设置为这个元素的innerText(ie支持)或者textContent(火狐，google支持)
        (temp.textContent != undefined ) ? (temp.textContent = html) : (temp.innerText = html);
        //3.最后返回这个元素的innerHTML，即得到经过HTML编码转换的字符串了
        var output = temp.innerHTML;
           temp = null;
           return output;
    },
    /*2.用浏览器内部转换器实现html解码*/
    htmlDecode:function (text){
        //1.首先动态创建一个容器标签元素，如DIV
        var temp = document.createElement("div");
        //2.然后将要转换的字符串设置为这个元素的innerHTML(ie，火狐，google都支持)
        temp.innerHTML = text;
        //3.最后返回这个元素的innerText(ie支持)或者textContent(火狐，google支持)，即得到经过HTML解码的字符串了。
        var output = temp.innerText || temp.textContent;
        temp = null;
        return output;
    }
};
//失败
window.error=function(txet){
    $('body').append('<div class="error"><img width="16" height="16" src="https://account.aiseesoft.com/images/error-2.svg" alt="Error">'+txet+'</div>');
    setTimeout(function(){
        $('body>.error').fadeOut();
    },5000);
}
$(document).click(function(){
    $('body>.success').fadeOut();
    $('body>.error').fadeOut();
});
// 超时错误
window.overtime=function(num){
    error(i18n[lang].overtime_1+num+i18n[lang].overtime_2);
}
window.error_fn=function(id){
    switch(id){
        case 20001:
            error(i18n[lang].error_20001);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            setCookie("user","",-1)
            user="";
            return false;
            break;
        case 20002:
            error(i18n[lang].error_20002);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20003:
            error(i18n[lang].error_20003);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20004:
            error(i18n[lang].error_20004);
            return false;
            break;
        case 20005:
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20006:
            error(i18n[lang].error_20006);
            return false;
            break;
        case 20007:
            error(i18n[lang].error_20007);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20008:
            error(i18n[lang].error_20008);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
        case 20009:
            error(i18n[lang].error_20009);
            if($(window).width()>980){
                $('.header .right span').show();
            }
            $('.header .right .login img').attr('src',oldImgUrl)
            $('.header .right .login').addClass('MemberLogin');
            user="";
            setCookie("user","",-1)
            return false;
            break;
    }
    return true;
}
window.setCookie=function(name,value,iDay){
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    if(location.hostname.indexOf('.aiseesoft.com')>-1){
        document.cookie = name + '=' + value + ';path=/;domain='+domain+';expires=' + oDate;
    }else{
        document.cookie = name + '=' + value + ';path=/;expires=' + oDate;
    }
}

// 判断是否有传参进入
window.getQueryVariable=function(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}
$(document).on('click','.MemberLogin',function(){
    if(String($(this).attr('class').indexOf('MemberLogin'))>-1){
        $('.maskMember').show()
    }
})
